<template>
    <div class="border-b-2 border-black space-y-2">
        <p class="font-bold inline-flex items-center border-b-2 w-full p-3">
            <CreditCards class="flex-none" width="25"/>
            <span class="ml-3">Оплата</span>
        </p>
        <div class="p-4 pt-1">
            <p>- <span class="font-bold">карткою</span> Visa/MasterCard, Apple Pay, Google Pay</p>
            <p>- на <span class="font-bold">розрахунковий рахунок</span> для ФОП та ТОВ</p>
            <p>- <span class="font-bold">250+ криптовалютами</span></p>
        </div>
    </div>
</template>

<script>
import CreditCards from "@/Components/Svg/CreditCards.vue";

export default {
    components: {CreditCards}
}
</script>
